module.exports = __webpack_public_path__ + "img/box2_img_dark.02f36c60.png";